import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

// menu item imports
import { addApplianceSkuLayerMenuItem } from '../menu-item/add-appliance-sku-layer-menu-item';
import { addCountertopCutoutMenuItem } from '../menu-item/add-countertop-cutout-menu-item';
import { addSpacerMenuItem } from '../menu-item/add-spacer-menu-item';
import { countertopPropertiesMenuItem } from '../menu-item/countertop-properties-menu-item';
import { deleteIslandMenuItem } from '../menu-item/delete-island-menu-item';
import { downloadDxfMenuItem } from '../menu-item/download-dxf-menu-item';
import { editIslandMenuItem } from '../menu-item/edit-island-menu-item';
import { insertBreakpointMenuItem } from '../menu-item/insert-breakpoint-menu-item';
import { islandPropertiesMenuItem } from '../menu-item/island-properties-menu-item';

export const countertopMenuList: Array<ContextMenuList> = [
	editIslandMenuItem(),
	addApplianceSkuLayerMenuItem(),
	addCountertopCutoutMenuItem(),
	addSpacerMenuItem(),
	insertBreakpointMenuItem(),
	downloadDxfMenuItem(),
	{ type: ContextMenuListItemType.Divider },
	deleteIslandMenuItem(),
	{ type: ContextMenuListItemType.Divider },
	islandPropertiesMenuItem(),
	countertopPropertiesMenuItem()
];
